import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

export const propertyVendorAccountIdQueryKeys = {
  all: ['accommodation', 'property-vendor-account-id'] as const,
  details: () => [...propertyVendorAccountIdQueryKeys.all, 'detail'] as const,
  detail: (propertyId: string) => [...propertyVendorAccountIdQueryKeys.details(), propertyId] as const,
};

interface UseGetPropertyVendorAccountIdParams {
  propertyId: string;
  enabled?: boolean;
}

export function useGetPropertyVendorAccountId({ propertyId, enabled = true }: UseGetPropertyVendorAccountIdParams) {
  return useQuery({
    queryKey: propertyVendorAccountIdQueryKeys.detail(propertyId),
    queryFn: async ({ signal }) => {
      const response = await ReservationService.getProperty(propertyId, { signal });

      if (!response || typeof response !== 'object' || !('result' in response)) {
        throw new Error('Unable to resolve property vendor account id');
      }

      return response.result?.id_salesforce_external || null;
    },
    enabled: enabled && !!propertyId,
  });
}
